import { render, staticRenderFns } from "./SidebarMenuActionItem.vue?vue&type=template&id=4b2535eb&scoped=true&"
import script from "./SidebarMenuActionItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuActionItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMenuActionItem.vue?vue&type=style&index=0&id=4b2535eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2535eb",
  null
  
)

export default component.exports